import React, { useState } from 'react';
import { find } from 'lodash';
import numeral from 'numeral';

// material
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import ChatBubble from '@material-ui/icons/ChatBubble';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import {
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Hidden,
  useMediaQuery
} from '@material-ui/core';
// entities
import { CampaignContact, Campaign } from '../../../entities/site';
import { ContactData } from '../Campaign';
// components
import ActionButtons from './ActionButtons';
import MessageHeader from './MessageHeader';
import MessageGroup from './MessageGroup';
import PropertyHeader from './PropertyHeader';
import Property from './Property';
// containers
import Loader from '../../../containers/Loader';
// services
import AuthService from '../../../services/auth';

interface CampaignContactPanelProps {
  contact: CampaignContact;
  campaign: Campaign;
  showLoader: boolean;
  contactData: ContactData[];
  onPanelOpen(contact: CampaignContact, isMobile: boolean): void;
  onSendMessage(contact: CampaignContact, message: string): void;
  onRefresh(contact: CampaignContact): void;
  onEdit(contact: CampaignContact): void;
  onOpen(contact: CampaignContact): void;
  onPropertyLoad(contact: CampaignContact): void;
  onFavorite(contact: CampaignContact): void;
}

const CampaignContactPanel: React.FC<CampaignContactPanelProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const displayMessages = (contact: CampaignContact, campaign: Campaign) => {
    const data = find(props.contactData, { id: contact.id }) as ContactData;
    if (data && data.messages.length) {
      return (
        <MessageGroup messageGroup={data.messageGroup} messages={data.messages} />
      )
    } else {
      return <div>Message thread not started</div>;
    }
  }

  const displayProperty = (contact: CampaignContact) => {
    const data = find(props.contactData, { id: contact.id }) as ContactData;
    console.log('data', data);
    if (data && data.address) {
      // numeral(props.rate).format('0.0')
      return (
        <div>
          <PropertyHeader contact={contact} onPropertyLoad={() => props.onPropertyLoad(contact)} />
          <Property address={data.address} />
        </div>
      )
    } else {
      return <PropertyHeader contact={contact} onPropertyLoad={() => props.onPropertyLoad(contact)} />;
    }
  }

  const displayFavorite = (contact: CampaignContact) => {
    const user = AuthService.getUser();
    const searchId = `${user?.userId}|${contact.id}`;

    if (contact.favoriteId && contact.favoriteId.indexOf(searchId) !== -1) {
      return <Favorite style={{ color: '#29C7E2' }} />
    }
    return <FavoriteBorder style={{ color: '#29C7E2' }} />
  }

  const handleFavorite = (event: any, contact: CampaignContact) => {
    event.stopPropagation();
    props.onFavorite(props.contact)
  }

  const handlePanelOpen = (contact: CampaignContact) => {
    if (matches) {
      props.onPanelOpen(contact, true);
    }
    props.onPanelOpen(contact, false);
  }

  return (
    <ExpansionPanel onChange={() => handlePanelOpen(props.contact)}>
      <ExpansionPanelSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Grid container>
          <Grid item xs={5} sm={3} md={3} className={classes.columnName}>{props.contact.firstName} {props.contact.lastName}</Grid>
          <Grid item xs={4} sm={2} md={2}>
            <div>{props.contact.phoneNumber}</div>
            <div>{(props.contact.email ? props.contact.email : 'N/A')}</div>
          </Grid>
          <Hidden only={['xs', 'sm']}>
            <Grid item xs={2} sm={2} md={2}>{(props.contact.city ? props.contact.city : 'N/A')}</Grid>
          </Hidden>
          <Hidden only={['xs', 'sm']}>
            <Grid item xs={2} sm={1} md={1}>{props.contact.status}</Grid>
          </Hidden>
          <Hidden only={['xs', 'sm']}>
            <Grid item xs={2} sm={2} md={2}>{props.contact.shortLink ? props.contact.shortLink : 'N/A'}</Grid>
          </Hidden>
          <Grid item xs={2} sm={2} md={2}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{marginLeft: 10, marginRight: 10, width: 20}}>{props.contact.newMessage ? <ChatBubble style={{ color: '#4CAF50', width: 20 }} /> : null}</div>
              <div style={{marginLeft: 10, marginRight: 10}} onClick={(event) => handleFavorite(event, props.contact)}>{displayFavorite(props.contact)}</div>
            </div>
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Loader open={props.showLoader}>
          <Grid container spacing={4}>
            <Grid item xs={8}>
              <MessageHeader
                contact={props.contact}
                campaign={props.campaign}
                hideOpen
                onEdit={props.onEdit}
                onRefresh={props.onRefresh}
                onOpen={props.onOpen}
                onSendMessage={props.onSendMessage}
              />
              {displayMessages(props.contact, props.campaign)}
            </Grid>
            <Grid item xs={4}>
              {displayProperty(props.contact)}
            </Grid>
          </Grid>
        </Loader>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );

}

export default CampaignContactPanel;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      color: '#29C7E2'
    },
    columnName: {
      color: '#29C7E2',
      fontSize: '18px',
      textAlign: 'left',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
      }
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/CampaignContactPanel.tsx